<template>
  <div class="popup_wrap sr_notice_pop" style="width:800px;">
    <button type="button" class="layer_close" @click="$emit('close')">close</button>
    <div class="popup_cont">
      <h1 class="page_title">{{ $t($t('msg.ONEX060P011_SR.001')) }}<!-- S/R 제출 --></h1>
      <div class="content_box">
        <table class="tbl_col">
          <colgroup>
            <col width="50%">
            <col width="50%">
          </colgroup>
          <thead>
            <tr>
              <th>{{ $t('msg.ONEX060P011_SR.002') }}<!-- S/R 제출시 주의사항 --></th>
              <th>{{ $t('msg.ONEX060P011_SR.003') }}<!-- S/R 제출 요청서 --></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text_left valign_top">
                <div class="p10" v-html="$t('msg.ONEX060P011_SR.004')">
                  <!-- B/L 수정 시 주의사항 - 설명 -->
                </div>
              </td>
              <td class="text_left valign_top">
                <div class="p10" v-html="$t('msg.ONEX060P011_SR.005')">
                  <!-- 수정 요청시(Correction Advice) - 설명 -->
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="mt10">
          <input type="checkbox" id="agreea1" name="agree" v-model="agreeYn" true-value="Y" false-value="N">
          <label for="agreea1" class="color_black" v-html="$t('msg.ONEX060P011_SR.006')">
            <!-- B/L 수정 시 주의사항을 충분히 인지하고 수정 요청서를 고려해운으로 발송함. -->
          </label>
        </p>
      </div>
      <div class="text_center mt10">
        <a href="#" class="button blue lg" @click.prevent="goModify('OK')">{{ $t('msg.ONEX060P011.007') }}<!-- 확인 --></a>
        <a href="#" class="button gray lg" @click.prevent="goModify('CLOSE')">{{ $t('msg.ONEX060P011.008') }}<!-- 취소 --></a>
      </div>
    </div>
  </div>
</template>

<script>
import { rootComputed } from '@/store/helpers'

export default {
  name: 'SrNoticePop',
  props: {
    parentInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      agreeYn: 'N',
      lang: ''
    }
  },
  computed: {
    ...rootComputed
  },
  created () {
    this.lang = this.auth.serviceLang
  },
  methods: {
    goModify (flag) {
      // console.log(this.$props.parentInfo)

      if (flag === 'OK' && this.agreeYn !== 'Y') {
        this.$ekmtcCommon.asyncAlertMessage({ message: this.$t('art.CMATK335') }) // 약관에 동의 하여야 합니다.
        return
      }

      this.$emit('selectFunc', flag)
      this.$emit('close')
    }
  }
}
</script>
